import React from "react";
import Banner from "./Banner";
import Features from "./Features";
import HowItWorks from "./HowItWorks";
import CallToAction from "./CallToAction";

const Homepage = () => {
	return (
		<div className="overflow-hidden">
			<Banner />
			<div id="features">
				<Features />
			</div>
			<HowItWorks />
			<CallToAction />
		</div>
	);
};

export default Homepage;
